import React, {Component} from 'react';
import produce from 'immer';
import withLifecycles from 'async-lifecycles';
import {Button, Message, Table, Icon} from 'semantic-ui-react';
import {Link} from 'react-router-dom';

import settingsApi from '../../store/services/settings';
import Page from '../layout/Page';
import FormContainer from '../form-components/FormContainer';

class List extends Component {
  state = {
    loading: false,
    settings: {},
  };

  componentDidMount() {
    this._loadSettings();
  }

  _loadSettings = () => {
    withLifecycles(
      () => settingsApi.fetch(),
      ({loading, data, error}) => {
        this.setState(
          produce(draft => {
            draft.loading = loading;

            if (data && !data.hasErrors) {
              draft.settings = data.result || [];
            }
          })
        );
      }
    );
  };

  render() {
    const {settings} = this.state;

    return (
      <Page.Basic title="Settings">
        <FormContainer loading={this.state.loading}>
          {settings.length === 0 && <Message info>No Settings</Message>}
          {settings.length > 0 && (
            <Table basic="very" selectable>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell />
                  <Table.HeaderCell>Name</Table.HeaderCell>
                  <Table.HeaderCell>Value</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>{settings.map(this._renderRow)}</Table.Body>
            </Table>
          )}
        </FormContainer>
      </Page.Basic>
    );
  }

  _renderRow = setting => {
    return (
      <Table.Row role="button" key={setting.id}>
        <Table.Cell collapsing>
          <Button
            basic
            icon
            as={Link}
            to={`/manage/settings/${setting.id}/edit`}
          >
            <Icon name="edit" />
          </Button>
        </Table.Cell>
        <Table.Cell>{setting.key}</Table.Cell>
        <Table.Cell>
          {setting.value.length > 100
            ? `${setting.value.substring(0, 100)}...`
            : setting.value}
        </Table.Cell>
      </Table.Row>
    );
  };
}

export default List;
